<template>

  <body>


  <!-- ============================================ -->
  <!-- AFFICHAGE AVEC LE MENU DE GROUPE A GAUCHE -->
  <!-- ============================================ -->

  

  <div v-if="dashboardFlags['evsensAdminFlag']" id="page-container" class="sidebar-l sidebar-o header-navbar-fixed" v-bind:class="{ 'sidebar-o-xs': sidebarIsActive }">

    <!-- Sidebar -->
    <nav id="sidebar">
      <!-- Sidebar Scroll Container -->
      <div id="sidebar-scroll">
        <!-- Sidebar Content -->
        <!-- Adding .sidebar-mini-hide to an element will hide it when the sidebar is in mini mode -->
        <div class="sidebar-content">
          <!-- Side Header -->
          <div class="side-header side-content bg-white-op">
            <!-- Layout API, functionality initialized in App() -> uiLayoutApi() -->
            <button class="btn btn-link text-gray pull-right hidden-md hidden-lg" type="button" data-toggle="layout" v-on:click="displaySidebar()"
                    data-action="sidebar_close">
              <i class="fa fa-times"></i>
            </button>
            <!-- Themes functionality initialized in App() -> uiHandleTheme() -->
            <a class="h5 text-white">
              <i class="fa fa-circle-o-notch text-success"></i> <span class="h4 font-w600 sidebar-mini-hide">{{profileData.licences[0].licenceLabel[actualLanguage]}}</span>
            </a>
          </div>
          <!-- END Side Header -->

          <!-- Side Content -->
          <!-- Premier niveau de groupe usager -->
          <!--
          <div class="side-content side-content-full">
              <ul class="nav-main">
                  <li class="nav-main-heading"><span class="sidebar-mini-hide"><font size="2" color="#2E2E2E">_________________________</font></span></li>
              </ul>
          </div>
          -->

          <div class="block-content">
            <button @click="actualiserArborescence()" class="btn btn-block btn-success" type="button"><i
              class="fa fa-repeat pull-left"></i>{{ buttonLabelRefresh[actualLanguage] }}
            </button>
            <button @click="goHomeGroup()" class="btn btn-block btn-success" type="button"><i
              class="fa fa-home fa-2x pull-left"></i><font size="3" color="white">Home</font></button>
          </div>


          <div class="block-content">

            <ul v-if="flagArborescenceIsLoading == false" class="nav-main">

              <li class="nav-main-heading"><span class="sidebar-mini-hide"><font size="3">{{ menuLabelGroup[actualLanguage] }}</font></span>
              </li>
              <div v-if="flagGroupSelectedByBundle===false">
                <div v-for="(group,index) in groupParentTempo">

                  <div v-if="group.sub_group.length">
                    <div v-if="flagGroupInParentSelect[index]">
                      <li class="open">
                        <a v-if="group.group_id.includes('DefaultGroup',1)" class=nav-submenu
                           @click="selectFirstLevelGroup(index)"><i class="fa fa-user fa-1x push-5-r "></i><font
                          size="2">{{ group.group_name }}</font></a>
                        <a v-else class=nav-submenu @click="selectFirstLevelGroup(index)"><i
                          class="fa fa-users fa-1x push-5-r "></i><font size="2">{{ group.group_name }}</font></a>

                        <ul v-if="group.sub_group.length">
                          <div v-for="(subGroup,index2) in group.sub_group">
                            <li>
                              <a @click="selectSecondLevelGroup(index2)">{{subGroup.group_name}}</a>
                            </li>
                          </div>
                        </ul>

                      </li>

                    </div>
                    <div v-else>
                      <li>
                        <a v-if="group.group_id.includes('DefaultGroup',1)" class=nav-submenu
                           @click="selectFirstLevelGroup(index)"><i class="fa fa-user fa-1x push-5-r "></i><font
                          size="2">{{ group.group_name }}</font></a>
                        <a v-else class=nav-submenu @click="selectFirstLevelGroup(index)"><i
                          class="fa fa-users fa-1x push-5-r "></i><font size="2">{{ group.group_name }}</font></a>
                      </li>

                    </div>
                  </div>

                  <div v-else>
                    <div v-if="flagGroupInParentSelect[index]">
                      <li class="open">
                        <a v-if="group.group_id.includes('DefaultGroup',1)" class="active"
                           @click="selectFirstLevelGroup(index)"><i class="fa fa-user fa-1x push-5-r "></i><font
                          size="2">{{ group.group_name }}</font></a>
                        <a v-else class="active" @click="selectFirstLevelGroup(index)"><i
                          class="fa fa-users fa-1x push-5-r "></i><font size="2">{{ group.group_name }}</font></a>
                      </li>
                    </div>
                    <div v-else>
                      <li>
                        <a v-if="group.group_id.includes('DefaultGroup',1)" @click="selectFirstLevelGroup(index)"><i
                          class="fa fa-user fa-1x push-5-r "></i><font size="2">{{ group.group_name }}</font></a>
                        <a v-else @click="selectFirstLevelGroup(index)"><i class="fa fa-users fa-1x push-5-r "></i><font
                          size="2">{{ group.group_name }}</font></a>
                      </li>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="block-content">
                  <button v-if="flagPersonalGroupSelected" class="btn btn-block btn-default" type="button" style="white-space: normal"><i
                    class="fa fa-user fa-2x pull-left"></i><font size="2" color="black">{{actualGroup.group_name}}</font>
                  </button>
                  <button v-else class="btn btn-block btn-default" type="button" style="white-space: normal"><i
                    class="fa fa-users fa-2x pull-left"></i><font size="2" color="black">{{actualGroup.group_name}}</font>
                  </button>
                </div>
              </div>




              <div v-if="flagGroupSelected">

                <div class="block-content push-10">
                </div>
                <div class="block-content push-10">
                </div>

                <li class="nav-main-heading"><span class="sidebar-mini-hide"><font size="3">{{ menuLabelSystem[actualLanguage] }}</font></span>
                </li>




                <div v-for="(bundle,index) in bundleParentTempo.bundles">
                  <div v-if="bundle.sub_bundle.length">
                    <div v-if="flagBundleInParentSelect[index]">
                      <li class="open">
                        <a class=nav-submenu @click="selectFirstLevelBundle(index)"><i
                          class="fa fa-usb fa-1x push-5-r "></i><font size="2">{{ bundle.bundle_name }}</font></a>

                        <ul v-if="bundle.sub_bundle.length">
                          <div v-for="(subBundle,index2) in bundle.sub_bundle">
                            <li>
                              <a @click="selectSecondLevelBundle(index2)">{{subBundle.ReferenceName}}</a>
                            </li>
                          </div>
                        </ul>
                      </li>
                    </div>
                    <div v-else>
                      <li>
                        <a class=nav-submenu @click="selectFirstLevelBundle(index)"><i
                          class="fa fa-usb fa-1x push-5-r "></i><font size="2">{{ bundle.bundle_name }}</font></a>
                      </li>
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="flagBundleInParentSelect[index]">
                      <li class="open">
                        <a class="active" @click="selectFirstLevelBundle(index)"><i
                          class="fa fa-usb fa-1x push-5-r "></i><font size="2">{{ bundle.bundle_name }}</font></a>
                      </li>
                    </div>
                    <div v-else>
                      <li>
                        <a @click="selectFirstLevelBundle(index)"><i class="fa fa-usb fa-1x push-5-r "></i><font
                          size="2">{{ bundle.bundle_name }}</font></a>
                      </li>
                    </div>
                  </div>
                </div>

                <div class="block-content push-10">
                </div>

                <div v-if="flagGroupSelectedByBundle" class="block-content">
                  <button  @click="loadSelectedBundle()" class="btn btn-block btn-success" type="button">
                    <spinner size="small" v-if="flagBundleIsLoading"></spinner>
                    <span v-else><i class="fa fa-cloud-download pull-left"></i>{{ buttonLabelReadSystem[actualLanguage] }}</span>
                  </button>
                </div>


              </div>

            </ul>
            <spinner v-else></spinner>
          </div>
          <!-- END Side Content -->
        </div>


        <!-- Sidebar Content -->
      </div>
      <!-- END Sidebar Scroll Container -->
    </nav>
    <!-- END Sidebar -->


    <!-- Header -->
    <header id="header-navbar" class="content-mini content-mini-full">

      <div class="row">

        <div class="col-md-12">
          <div class="content-mini content-mini-full content-boxed">
            <ul class="nav-header pull-left">
              <li class="hidden-md hidden-lg">
                <button class="btn btn-default" data-toggle="layout" data-action="sidebar_toggle" type="button" v-on:click="displaySidebar()">
                  <i class="fa fa-navicon"></i>
                </button>
              </li>
              
              <li class="header-content">
                <a class="h4 main-logo" href="/">
                  <img src="./assets/logo_v2_vertical_B_small.png">
                </a>
              </li>


            </ul>

            <ul class="nav-header pull-right">
              <li v-if="mobile==false && displayElIot">
                <h3 class="h3 block-title">{{messageAcceuil[actualLanguage]}} {{ profileData.profileInfo.firstName }} </h3>
              </li>

              <li v-if = "displayHeadMenuShowHideButton && mobile==false">
                <a href="#" @click="toggleShowHideHead()" class="btn btn-default">
                  <span v-if="displayHeadMenu" style="font-size:12px">{{ displayHideHeadMenuClose[actualLanguage]}}</span>
                  <span v-else style="font-size:12px">{{ displayHideHeadMenuOpen[actualLanguage]}}</span>
                </a>
              </li>

              <li v-if="mobile==false">
                <a href="#" @click="toggleLanguage()" class="btn btn-default">
                  <span><i class="si si-settings" ></i> {{ actualLanguage }}</span>
                </a>
              </li>
              <li v-else>
                <a href="#" @click="toggleLanguage()" class="btn btn-default" style="width:40px">
                  <span style="font-size:10px">{{ actualLanguage }}</span>
                </a>
              </li>

              <li v-if="mobile==false">
                <a href="#" @click="logOut()" class="btn btn-default">
                  <i class="si si-power"></i>
                </a>
              </li>
              <li v-else>
                <a href="#" @click="logOut()" class="btn btn-default" style="width:35px">
                  <i class="si si-power"></i>
                </a>
              </li>

            </ul>
          </div>
        </div>


        <div v-if="displayHeadMenu" class="row">
          <div v-if="mobile==false" class="col-md-12 text-left">
            <hr></hr>
            <ol class="breadcrumb push-10-t">
              <li><a @click="goHomeGroup()" class="link-effect"><font size="3"><i class="fa fa-search"></i> Home</font></a></li>
              <li v-for="(navItem,index) in navBarLink">
                <a @click="goBackNav(index)" class="link-effect"><i v-if="navItem.Type==='GU'" class="fa fa-users fa-1x push-5-r "></i><i
                  v-if="navItem.Type==='GS'" class="fa fa-usb fa-1x push-5-r "></i><font
                  size="3">{{navItem.Name}}</font></a>
              </li>
            </ol>
            <hr></hr>
          </div>
          <div v-if="flagGroupSelected">

            <div v-if="mobile==false" class="col-md-12 text-left">
              <h3><i v-if="flagPersonalGroupSelected==false" class="fa fa-industry push-5-r"></i>{{actualGroup.rightsProviderName}}
              </h3>
              <hr></hr>
            </div>

          </div>
        </div>

        <div v-if="flagBundleIsLoaded">
          <div class="row">
            <div class="col-xs-12">

              <div class="bg-gray-lighter visible-xs">
                  <div class="content-mini content-boxed">
                    <button class="btn btn-block btn-default visible-xs push collapsed" data-toggle="collapse"
                            data-target="#sub-header-nav" aria-expanded="false">
                      <i class="fa fa-navicon push-5-r"></i>Menu
                    </button>
                  </div>
                
              </div>


              <div class="bg-gray-darker navbar-collapse remove-padding collapse" id="sub-header-nav">
                <div class="content-mini content-boxed">
                  <ul class="nav nav-pills nav-sub-header push">

                    <li class = "btnmenu" v-if="false" @click = "headerMenuSelectedTab=1">
                      <router-link class="text-white" :to="{name: 'profile'}">
                        <i class="fa fa-user push-5-r"></i> {{ labelProfileButton[actualLanguage] }}
                      </router-link>
                      </a>
                    </li>

                    <li class = "btnmenu" v-if="actualBundle.cars.length && profileData.profileConfig.displayEvConfig.value" @click = "headerMenuSelectedTab=2">
                      <router-link class="text-white" :to="{name: 'ports'}">
                        <i class="fa fa-car push-5-r"></i> {{ labelPortButton[actualLanguage] }}
                      </router-link>
                      </a>
                    </li>


                    <li class = "btnmenu" @click = "headerMenuSelectedTab=3">
                      <router-link class="text-white" :to="{name: 'measurements'}">
                        <i class="fa fa-television push-5-r"></i> {{ labelMesElcButton[actualLanguage] }}
                      </router-link>
                      </a>
                    </li>

                    <li class = "btnmenu" v-if="flagDisplayCostSplittingMenu" @click = "headerMenuSelectedTab=4">
                      <router-link class="text-white" :to="{name: 'cost-splitting'}">
                        <i class="fa fa-dollar push-5-r"></i> {{ labelSplitCostButton[actualLanguage] }}
                      </router-link>
                      </a>
                    </li>



                    <li class = "btnmenu" @click = "headerMenuSelectedTab=5">
                      <router-link class="text-white" :to="{name: 'configuration'}">
                        <i class="fa fa-sliders push-5-r"></i> Configuration
                      </router-link>
                      </a>
                    </li>

                    <li class = "btnmenu" v-if="profileData.sharingInvitations.length>0" @click = "headerMenuSelectedTab=6">
                      <router-link class="text-white" :to="{name: 'sharing'}">
                        <i class="fa fa-share-alt push-5-r fa-1x"></i> {{labelSharingButton[actualLanguage]}} <i class="fa fa-exclamation-circle push-5-r fa-1x"></i>
                      </router-link>
                      </a>
                    </li>


                    <li class = "btnmenu" @click = "headerMenuSelectedTab=7">
                      <router-link class="text-white" :to="{name: 'help'}">
                          <i class="fa fa-question push-5-r"></i> {{labelHelpButton[actualLanguage]}}
                      </router-link>
                      </a>
                    </li>

                    <li class = "btnmenu" v-if="dashboardFlags.evsensMasterFlag" @click = "headerMenuSelectedTab=8">
                      <router-link class="text-white" :to="{name: 'evsensadmin'}">
                        <i class="fa fa-server push-5-r"></i> EV Sens Admin
                      </router-link>
                      </a>
                    </li>



                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>

    </header>
    <!-- END Header -->


    <!-- Main Container -->
    <main id="main-container">
      <!-- Page Content -->
      <div class="content">


        <div class="row">
          <div class="col-md-12 push">
          </div>
          <div class="col-md-12 push">
          </div>
        </div>

        <div v-if="flagBundleIsLoading" class="row">
          <div class="col-md-12 push">
          </div>
          <div class="col-md-12 push">
          </div>
          <div class="col-md-12 push">
          </div>
          <div class="col-md-12 push">
          </div>
          <div class="col-md-12 push">
          </div>
          <div class="col-md-12 push">
          </div>
          <div class="col-md-12 align-center push">
            <h3 class="font-w300 push-10">{{messageLoading[actualLanguage]}}</h3>
            <spinner></spinner>
          </div>

        </div>
        <div v-else class="row">

          <div class="col-md-12 push">
          </div>
          <div v-if="mobile==false" class="col-md-12 push">
          </div>
          <div v-if="mobile==false" class="col-md-12 push">
          </div>
          <div v-if="mobile==false" class="col-md-12 push">
          </div>
          <div v-if="mobile==false" class="col-md-12 push">
          </div>
          <div v-if="mobile==false" class="col-md-12 push">
          </div>


          <div v-if="flagBundleIsLoaded">
            <div class="content content-boxed">

              <div v-if="mobile">
                <div v-if="headerMenuSelectedTab==3 || headerMenuSelectedTab==4" class="col-xs-12 col-md-12 push">
                  <button @click="loadSelectedBundle()" class="btn btn-block btn-success" type="button" style = "font-size:12px">
                    <i class="fa fa-cloud-download pull-left"></i><i class="fa fa-refresh pull-left"></i>{{ buttonLabelReadRefreshSystem[actualLanguage] }}
                  </button>
                </div>
              </div>
              <div v-else>
                <div v-if="headerMenuSelectedTab==3 || headerMenuSelectedTab==4" class="col-xs-12 col-md-12 push">
                  <button @click="loadSelectedBundle()" class="btn btn-block btn-success" type="button">
                    <i class="fa fa-cloud-download pull-left"></i><i class="fa fa-refresh pull-left"></i>{{ buttonLabelReadRefreshSystem[actualLanguage] }} : {{bundleTempo.bundle_name}}
                  </button>
                </div>
              </div>

              <router-view></router-view>
            </div>
          </div>

          <div v-else>

              <div v-if="flagDisplayHome">


                <!-- =========================================================================== -->
                <!-- =========================================================================== -->
                <!-- Home Tab Menu to see Profile, Organisation, First level group creation and research -->
                <!-- =========================================================================== -->
                <!-- =========================================================================== -->
                <div class="content content-boxed">
                  <div class="row">
                    <div class="col-xs-12">
                      <div v-if="displayHomeTab" class="block">

                        <ul class="nav nav-tabs nav-tabs-alt nav-justified" data-toggle="tabs">

                          <li :class="{'active': homeTabMenuSelector[0]==true}"  @click="toggleHomeTabMenuSelector(0)">
                              <a ><i class="fa fa-user"></i> {{homeTabMenuProfile[actualLanguage] }}</a>
                          </li>

                          <li :class="{'active': homeTabMenuSelector[1]==true}"  @click="toggleHomeTabMenuSelector(1)">
                              <a ><i class="fa fa-industry"></i> {{homeTabMenuOrganizations[actualLanguage] }}</a>
                          </li>

                          <li :class="{'active': homeTabMenuSelector[2]==true}"  @click="toggleHomeTabMenuSelector(2)">
                              <a ><i class="fa fa-users"></i> {{homeTabMenuFirstLevelGroup[actualLanguage] }}</a>
                          </li>

                          <li :class="{'active': homeTabMenuSelector[3]==true}"  @click="toggleHomeTabMenuSelector(3)">
                              <a ><i class="fa fa-search"></i> {{homeTabMenuResearch[actualLanguage] }}</a>
                          </li>

                          <li :class="{'active': homeTabMenuSelector[4]==true}"  @click="toggleHomeTabMenuSelector(4)">
                              <a ><i class="fa fa-question"></i> {{homeTabMenuHelp[actualLanguage] }}</a>
                          </li>
                        </ul>

                        <div class="block-content tab-content">

                          <!-- =========================================================================== -->
                          <!-- Tab My Profile -->
                          <!-- =========================================================================== -->
                          <div :class="{'tab-pane': true, 'active': homeTabMenuSelector[0]==true}" >
                            <div class="col-xs-12">
                              <profile-view></profile-view>
                            </div>
                          </div>

                          <!-- =========================================================================== -->
                          <!-- Tab My Organisations -->
                          <!-- =========================================================================== -->
                          <div :class="{'tab-pane': true, 'active': homeTabMenuSelector[1]==true}" >
                            <div class="col-xs-12">

                              <div v-if = "profileData.managed_organizations.length>0">
                                <h3 class="font-w300 push-10">{{sectionLabelOrganization[actualLanguage]}}</h3>
                              </div>

                              <div v-for="(organization,index) in profileData.managed_organizations">
                                <organization-display :organizationIndex="index" ></organization-display>
                              </div>

                              <div class="col-sm-12 col-md-6">
                                <p><button  @click="showModal('organization-add-form')" type="button" class="btn btn-success align-center" name="button" data-toggle="popover" v-bind:title=this.massageOrganizationRequired[this.actualLanguage]>
                                  <i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-industry fa-1x push-5-r "></i>{{ buttonLabelCreateOrganization[actualLanguage] }}</button></p>
                              </div>

                              <div v-if="false"  class="col-sm-12">                
                                <p><button @click="openMultiGroupDocumentation()" type="button" class="btn btn-block btn-success" name="button"><i class="fa fa-question-circle fa-1x push-10-r "></i>{{ buttonHelpManagerVersionDocumentation[actualLanguage] }}</button></p>
                              </div>

                            </div>
                          </div>


                          <!-- =========================================================================== -->
                          <!-- Tab First level group creation-->
                          <!-- =========================================================================== -->
                          <div :class="{'tab-pane': true, 'active': homeTabMenuSelector[2]==true}" >
                            <div class="col-xs-12">

                              <div v-if="userAcessLevel2Flag && profileData.managed_organizations.length > 0 && mobile==false" class="content content-boxed">
                                <div class="block-content">
                                  <div class="row push">
                                    <h3 class="font-w300 push-10">{{ textLabelCreateFirstLevelGroup[actualLanguage] }}</h3>
                                  </div>
                                </div>
                                <div class="block block-themed">

                                  <div class="block-content">

                                    <div class="row">
                                      <p>{{ textIndicationCreateFirstLevelGroup[actualLanguage] }} :  {{profileData.managed_organizations[actualOrganizationIndex].organizationName}}</p>
                                    </div>

                                    <div class="row push">
                                      <div class="col-xs-12 col-md-6 push">
                                        <div class="form-group">
                                          <label class="col-xs-12" for="example-select">{{ buttonLabelSelectGroup[actualLanguage] }} :</label>
                                          <div class="col-sm-9">
                                            <select class="form-control" v-model=actualOrganizationIndex size="1">
                                              <option v-for="(organization,index) in profileData.managed_organizations" :value="index">
                                                {{organization.organizationName}}
                                              </option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="col-sm-12 col-md-6">
                                        <p>
                                          <button @click="createNewGroupInOrganization()" type="button" class="btn btn-block btn-success" name="button">
                                            <spinner size="small" v-if="groupInOrganizationIsCreating"></spinner>
                                            <span v-else><i class="fa fa-plus fa-1x push-5-r "></i><i
                                              class="fa fa-users fa-1x push-5-r "></i>{{ buttonLabelCreateFirstLevelGroup[actualLanguage] }}</span>
                                          </button>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>


                          <!-- =========================================================================== -->
                          <!-- Tab Research -->
                          <!-- =========================================================================== -->
                          <div :class="{'tab-pane': true, 'active': homeTabMenuSelector[3]==true}" >
                            <div class="col-xs-12">


                                <div class="content content-boxed">
                                    <div class="block block-bordered">
                                      <div class="row">

                                        <div class="content content-boxed push">
                                            <h2 class="block-title">{{findElementSectionLabel[actualLanguage]}}</h2>
                                            <div class="input-group input-group-lg">
                                                <input class="form-control" type="text" @keyup.enter="researchInProfile()" v-model="stringToFind" placeholder="Rechercher/Search">
                                                <div class="input-group-btn">
                                                    
                                                    <button  class="btn btn-default"  @click="researchInProfile()">
                                                      <spinner size="small" v-if="researchInProgress"></spinner><i v-else class="fa fa-search"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    
                                        <div v-if= "searchDoneFlag" class="col-md-12">
                                          <div v-if= "researchResults.length>0" class="block-content">

                                            <div class="row">
                                                  <table class="table">
                                                      <thead>
                                                          <tr>
                                                              <th class="text-center" style="width: 5%;">{{ researchTableTitleType[actualLanguage] }}</th>
                                                              <th class="text-center" style="width: 50%;">{{ researchTableTitlePath[actualLanguage] }}</th>
                                                              <th class="text-center" style="width: 20%;">{{ researchTableTitleName[actualLanguage] }}</th>
                                                              <th class="text-center" style="width: 20%;">{{ researchTableTitleRefName[actualLanguage] }}</th>
                                                              <th class="text-center" style="width: 5%;">{{ researchTableTitleAction[actualLanguage] }}</th>
                                                          </tr>
                                                      </thead>
                                                      <tbody>   
                                                            <tr v-for="(findItem,index) in researchResults">
                                                                <td  class="text-center-bold">
                                                                  <i v-if ="findItem.EntityType==='Channel'" class="fa fa-television fa-2x push-5-r "></i>
                                                                  <i v-if ="findItem.EntityType==='Device'" class="fa fa-server fa-2x push-5-r "></i>
                                                                  <i v-if ="findItem.EntityType==='Bundle'" class="fa fa-usb fa-2x push-5-r "></i>
                                                                  <i v-if ="findItem.EntityType==='Group'" class="fa fa-users fa-2x push-5-r "></i>
                                                                  <i v-if ="findItem.EntityType==='Car'" class="fa fa-car fa-2x push-5-r "></i>
                                                                  
                                                                </td>
                                                                <td class="text-center" @click="researchResultGoToPath(index)">
                                                                  <p>{{findItem.EntityPath}}</p>
                                                                </td>
                                                                <td class="text-center">
                                                                    <p>{{findItem.EntityName}}</p>
                                                                </td>
                                                                <td class="text-center">
                                                                    <p>{{findItem.EntityReferenceName}}</p>
                                                                </td>
                                                                <td class="text-center">
                                                                  <button class="btn btn-default" type="button" @click="researchResultGoToPath(index)" data-toggle="tooltip" title="Aller à/ Go to"><i class="fa fa-folder-open"></i></button>
                                                                </td>
                                                            </tr>
                                                      </tbody>
                                                  </table>
                                              </div>
                                          </div>
                                          <div v-else class="col-md-12">
                                            <h3>{{findElementNoResults[actualLanguage]}}</h3>
                                          </div>
                                        
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                          </div>


                          <!-- =========================================================================== -->
                          <!-- Tab Help -->
                          <!-- =========================================================================== -->
                          <div :class="{'tab-pane': true, 'active': homeTabMenuSelector[4]==true}" >
                            <div class="col-xs-12">
                              <help-section></help-section>
                            </div>
                          </div>




                        </div>

                      </div>
                    </div>
                  
                  </div>
                </div>






                <!-- =========================================================================== -->
                <!-- =========================================================================== -->
                <!-- Tools to create new first level group in organisation -->
                <!-- =========================================================================== -->
                <!-- =========================================================================== -->

                <!--
                <div v-if="userAcessLevel2Flag && profileData.managed_organizations.length > 0 && mobile==false" class="content content-boxed">
                  <div class="block-content">
                    <div class="row push">
                      <h3 class="font-w300 push-10">{{ textLabelCreateFirstLevelGroup[actualLanguage] }}</h3>
                    </div>
                  </div>
                  <div class="block block-themed">

                    <div class="block-content">

                      <div class="row">
                        <p>{{ textIndicationCreateFirstLevelGroup[actualLanguage] }} :  {{profileData.managed_organizations[actualOrganizationIndex].organizationName}}</p>
                      </div>

                      <div class="row push">
                        <div class="col-xs-12 col-md-6 push">
                          <div class="form-group">
                            <label class="col-xs-12" for="example-select">{{ buttonLabelSelectGroup[actualLanguage] }} :</label>
                            <div class="col-sm-9">
                              <select class="form-control" v-model=actualOrganizationIndex size="1">
                                <option v-for="(organization,index) in profileData.managed_organizations" :value="index">
                                  {{organization.organizationName}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-12 col-md-6">
                          <p>
                            <button @click="createNewGroupInOrganization()" type="button" class="btn btn-block btn-success" name="button">
                              <spinner size="small" v-if="groupInOrganizationIsCreating"></spinner>
                              <span v-else><i class="fa fa-plus fa-1x push-5-r "></i><i
                                class="fa fa-users fa-1x push-5-r "></i>{{ buttonLabelCreateFirstLevelGroup[actualLanguage] }}</span>
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                -->






                <!-- =========================================================================== -->
                <!-- =========================================================================== -->
                <!-- Find Element In Profile -->
                <!-- =========================================================================== -->
                <!-- =========================================================================== -->
                
                <!--
                <div class="content content-boxed">
                    <div class="block block-bordered">
                      <div class="row">

                        <div class="content content-boxed push">
                            <h2 class="block-title">{{findElementSectionLabel[actualLanguage]}}</h2>
                            <div class="input-group input-group-lg">
                                <input class="form-control" type="text" @keyup.enter="researchInProfile()" v-model="stringToFind" placeholder="Rechercher/Search">
                                <div class="input-group-btn">
                                    
                                    <button  class="btn btn-default"  @click="researchInProfile()">
                                      <spinner size="small" v-if="researchInProgress"></spinner><i v-else class="fa fa-search"></i></button>
                                </div>
                            </div>
                        </div>
                    
                        <div v-if= "searchDoneFlag" class="col-md-12">
                          <div v-if= "researchResults.length>0" class="block-content">

                            <div class="row">
                                  <table class="table">
                                      <thead>
                                          <tr>
                                              <th class="text-center" style="width: 5%;">{{ researchTableTitleType[actualLanguage] }}</th>
                                              <th class="text-center" style="width: 50%;">{{ researchTableTitlePath[actualLanguage] }}</th>
                                              <th class="text-center" style="width: 20%;">{{ researchTableTitleName[actualLanguage] }}</th>
                                              <th class="text-center" style="width: 20%;">{{ researchTableTitleRefName[actualLanguage] }}</th>
                                              <th class="text-center" style="width: 5%;">{{ researchTableTitleAction[actualLanguage] }}</th>
                                          </tr>
                                      </thead>
                                      <tbody>   
                                            <tr v-for="(findItem,index) in researchResults">
                                                <td  class="text-center-bold">
                                                  <i v-if ="findItem.EntityType==='Channel'" class="fa fa-television fa-2x push-5-r "></i>
                                                  <i v-if ="findItem.EntityType==='Device'" class="fa fa-server fa-2x push-5-r "></i>
                                                  <i v-if ="findItem.EntityType==='Bundle'" class="fa fa-usb fa-2x push-5-r "></i>
                                                  <i v-if ="findItem.EntityType==='Group'" class="fa fa-users fa-2x push-5-r "></i>
                                                  <i v-if ="findItem.EntityType==='Car'" class="fa fa-car fa-2x push-5-r "></i>
                                                  
                                                </td>
                                                <td class="text-center" @click="researchResultGoToPath(index)">
                                                  <p>{{findItem.EntityPath}}</p>
                                                </td>
                                                <td class="text-center">
                                                    <p>{{findItem.EntityName}}</p>
                                                </td>
                                                <td class="text-center">
                                                    <p>{{findItem.EntityReferenceName}}</p>
                                                </td>
                                                <td class="text-center">
                                                  <button class="btn btn-default" type="button" @click="researchResultGoToPath(index)" data-toggle="tooltip" title="Aller à/ Go to"><i class="fa fa-folder-open"></i></button>
                                                </td>
                                            </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                          <div v-else class="col-md-12">
                            <h3>{{findElementNoResults[actualLanguage]}}</h3>
                          </div>
                        
                        </div>
                    </div>
                    </div>
                </div>
                -->
                



                <!-- =========================================================================== -->
                <!-- Tools to see sharings -->
                <!-- =========================================================================== -->
                <div v-if = "displayListSharingFlag" class="row push">
                  <div v-for="(invitation,index) in profileData.sharingInvitations" class="row push">

                    <div v-if="invitation.InvitationStatus=='Pending' & invitation.SharedEntityType=='Group'" class="col-sm-12">
                      <div v-if="groupConfigEditFlag" class="content content-boxed">
                        <div class="block-content">
                          <h4 class="font-w300 push-10">{{ textYouReceiveGroupSharing[actualLanguage] }}</h4>
                          <sharing-item :index="index"></sharing-item>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div v-else>


                <div class="col-sm-12 push-50">
                </div>

                
                <div v-if="flagBundleSelected===false">
                  <div v-if="groupConfigViewFlag && flagPersonalGroupSelected==false"> 
                    <div class="content content-boxed">

                      <div class="block-content">
                        <div class="row push">
                            <h2 class="font-w300 push-30">{{ textIndicationSelectAddGroupOrSystem[actualLanguage] }}</h2>
                            <h2 class="font-w300 push-10">{{ textIndicationAddOrModifyGroup[actualLanguage] }}</h2>
                            
                        </div>
                        <div class="col-sm-12 push">
                        </div> 
                        <div class="row push">
                          <h3 class="font-w300 push-10"><i class="fa fa-group fa-1x push-5-r "></i>{{actualGroup.group_name}}</h3>
                        </div>
                      </div>


                      <!-- =========================================================================== -->
                      <!-- Section de customer support reserved to EV Sens when group selected-->
                      <!-- =========================================================================== -->

                      <div v-if="flagShowCustomerSupportSection" class="block block-themed">
                        <div class="block-content">

                          <div class="row push">
                            <h4 class="font-w300 push-10"><i class="fa fa-user fa-1x push-5-r "></i>EV Sens Customer support</h4>
                          </div>

                          <div v-if="groupConfigEditFlag" class="row push">

                            <div class="col-lg-12 push">
                              <div class="col-sm-12 col-md-6">
                                <h4 class="font-w300 push-10">Use this button to create a non existing user profile and add its system in this group.</h4>
                              </div>
                              <div class="col-sm-12 col-md-6">
                                <p>
                                  <button @click="createNewUserProfile()" type="button" class="btn btn-block btn-success"
                                          name="button"><i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-user fa-1x push-5-r "></i><i
                                    class="fa fa-usb fa-1x push-5-r "></i>Create customer profile for pre-configuration</button>
                                </p>
                              </div>
                            </div>

                            <div class="col-lg-12 push">
                              <div class="col-sm-12 col-md-6">
                                <h4 class="font-w300 push-10">Use this button to add the default system of an existing user profile email. Note the added system will have a generic name. Don't add two generic name system at same time in the group.</h4>
                              </div>
                              <div class="col-sm-12 col-md-6">
                                <p>
                                  <button @click="addDefaultBundleOfExistingUser()" type="button" class="btn btn-block btn-success"
                                          name="button"><i class="fa fa-plus fa-1x push-5-r "></i><i
                                    class="fa fa-usb fa-1x push-5-r "></i>Add an existing customer profile bundle</button>
                                </p>
                              </div>
                            </div>


                            <div class="col-lg-12 push">
                              <div class="col-sm-12 col-md-6">
                                <h4 class="font-w300 push-10">Use this button to remove a specific system from this group.</h4>
                              </div>
                              <div class="col-sm-12 col-md-6">
                                <p>
                                  <button @click="removeSpecifiedSystem()" type="button" class="btn btn-block btn-success"
                                          name="button"><i class="fa fa-minus fa-1x push-5-r "></i><i class="fa fa-usb fa-1x push-5-r "></i>Remove specific system from this group</button>
                                </p>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>


                      <div class="block block-themed">
                        <div class="block-content">

                          <div class="row push">
                            <h4 class="font-w300 push-10"><i class="fa fa-plus fa-1x push-5-r "></i>{{ blocLabelAddComponentToGroupe[actualLanguage] }}</h4>
                          </div>

                          <div v-if="groupConfigEditFlag" class="row push">
                            <div class="col-sm-12 col-md-6">
                              <p>
                                <button @click="createNewGroupInGroup()" type="button" class="btn btn-block btn-success"
                                        name="button">
                                  <spinner size="small" v-if="groupInGroupIsCreating"></spinner>
                                  <span v-else><i class="fa fa-plus fa-1x push-5-r "></i><i
                                    class="fa fa-users fa-1x push-5-r "></i>{{ buttonLabelAddSubGroup[actualLanguage] }}</span>
                                </button>
                              </p>
                            </div>

                            <div class="col-sm-12 col-md-6">
                              <p>
                                <button @click="createNewBundleInGroup()" type="button" class="btn btn-block btn-success"
                                        name="button"><i class="fa fa-plus fa-1x push-5-r "></i><i
                                  class="fa fa-usb fa-1x push-5-r "></i>{{ buttonLabelAddSystemToGroup[actualLanguage] }} </button>
                              </p>
                            </div>
                          </div>




                          <div v-if="false"  class="row push">
                            <div v-if="groupSharingEnableFlag" class="col-sm-12 col-md-6">
                              <p>
                                <button @click="shareActualGroup()" type="button" class="btn btn-block btn-success"
                                        name="button">
                                  <i class="fa fa-share-alt fa-1x push-5-r "></i>{{ buttonLabelShareThisGroup[actualLanguage] }}</button>
                              </p>
                            </div>

                            <div v-if="groupConfigDeleteFlag" class="col-sm-12 col-md-6">
                              <p>
                                <button @click="deleteActualGroup()" type="button" class="btn btn-block btn-danger"
                                        name="button">
                                  <spinner size="small" v-if="groupIsDeleting"></spinner>
                                  <span v-else><i class="fa fa-trash fa-1x push-5-r "></i>{{ buttonLabelDeleteGroup[actualLanguage] }}</span>
                                </button>
                              </p>
                            </div>

                          </div>


                        </div>
                      </div>

                      <div class="block block-themed">
                        <div class="block-content">
                          <div class="row push">
                            <h4 class="font-w300 push-10"><i class="fa fa-sliders fa-1x push-5-r "></i>{{ blocLabelConfigGroup[actualLanguage] }}</h4>
                          </div>
                          <config-group ></config-group>
                        </div>
                      </div>

                    </div>

                    <div v-if = "displayListSharingFlag" class="row push">
                      <div v-for="(invitation,index) in profileData.sharingInvitations" class="row push">

                        <div v-if="invitation.InvitationStatus=='Pending' & invitation.SharedEntityType=='Group'" class="col-sm-12">
                          <div v-if="groupConfigEditFlag" class="content content-boxed">
                            <div class="block-content">
                              <h4 class="font-w300 push-10">{{ textYouReceiveGroupSharing[actualLanguage] }}</h4>
                              <sharing-item :index="index"></sharing-item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div v-if = "displayListSharingFlag" class="row push">
                      <div v-for="(invitation,index) in profileData.sharingInvitations" class="row push">

                        <div v-if="invitation.InvitationStatus=='Pending' & invitation.SharedEntityType=='Bundle'" class="col-sm-12">
                          <div v-if="groupConfigEditFlag" class="content content-boxed">
                            <div class="block-content">
                              <h4 class="font-w300 push-10">{{ textYouReceiveSystemSharing[actualLanguage] }}</h4>
                              <sharing-item :index="index"></sharing-item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                  <div v-else>
                    <div class="content content-boxed">
                      <div class="block-content">
                        <div class="row">
                          <h2 class="font-w300 push-10">{{ textIndicationSelectGroupOrSystem[actualLanguage] }}</h2>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div v-else class="content content-boxed">
                  <h3 class="font-w300 push-10">{{textMessageSelectAndPressReadSystem[actualLanguage]}}</h3>
                </div>

              </div>

              <!--
              <div v-if="flagDisplayProfileView && flagGroupSelected==false" class="content content-boxed">
                <profile-view></profile-view>
              </div>
              -->
            
          </div>
        </div>

      </div>
      <!-- END Page Content -->
    </main>
    <!-- END Main Container -->

    <!-- Footer -->
    <footer id="page-footer" class="content-mini content-mini-full font-s12 bg-gray-lighter clearfix">
      <div class="pull-right">
        <a class="font-w600" href="https://evsens.ca" target="_blank">Energisys  technologie</a> &copy; <span class="js-year-copy">2026</span>
      </div>
    </footer>
    <!-- END Footer -->

  </div>





  <!-- ============================================ -->
  <!-- AFFICHAGE SANS LE MENU DE GROUPE A GAUCHE -->
  <!-- ============================================ -->

  <div v-else id="page-container" class="sidebar-l side-scroll header-navbar-fixed" style="min-height: 100vh;">
    <header id="header-navbar">
      <div class="row">
        <div class="col-md-12">

          <div class="content-mini content-mini-full content-boxed">
            <ul class="nav-header pull-left">
              
              <li class="header-content">
                <a class="h5 main-logo" href="/">
                  <img src="./assets/logo_v2_vertical_B_small.png">
                </a>
              </li>


            </ul>

            <ul class="nav-header pull-right">
              <li v-if="mobile==false">
                <h3 class="h3 block-title">{{messageAcceuil[actualLanguage]}} {{ profileData.profileInfo.firstName }} </h3>
              </li>

              <li>
                <a href="#" @click="toggleLanguage()" class="btn btn-default">
                  <i class="si si-settings"></i> {{ actualLanguage }}
                </a>
              </li>

              <li>
                <a href="#" @click="logOut()" class="btn btn-default">
                  <i class="si si-power"></i>
                </a>
              </li>

            </ul>
          </div>
          <hr></hr>
        </div>

      </div>


      <div class="row">
        <div class="col-md-12">

          <div class="bg-gray-lighter visible-xs">
            <div class="content-mini content-boxed">
              <button class="btn btn-block btn-default visible-xs push collapsed" data-toggle="collapse"
                      data-target="#sub-header-nav" aria-expanded="false">
                <i class="fa fa-navicon push-5-r"></i>Menu
              </button>
            </div>
          </div>

          <div class="bg-gray-darker navbar-collapse remove-padding collapse" id="sub-header-nav">
            <div class="content-mini content-boxed">
              <ul class="nav nav-pills nav-sub-header push">

                <li class = "btnmenu">
                  <router-link class="text-white" :to="{name: 'profile'}">
                    <i class="fa fa-user push-5-r"></i> {{ labelProfileButton[actualLanguage] }}
                  </router-link>
                  </a>
                </li>

                <li class = "btnmenu"
                  v-if="profileData.rights.rights.dashboardEvLogFlag && profileData.profileConfig.displayEvConfig.value">
                  <router-link class="text-white" :to="{name: 'ports'}">
                    <i class="fa fa-car push-5-r"></i> {{ labelPortButton[actualLanguage] }}
                  </router-link>
                  </a>
                </li>

                <li class = "btnmenu">
                  <router-link class="text-white" :to="{name: 'measurements'}">
                    <i class="fa fa-flash push-5-r"></i> {{ labelMesElcButton[actualLanguage] }}
                  </router-link>
                  </a>
                </li>

                <li class = "btnmenu">
                  <router-link class="text-white" :to="{name: 'configuration'}">
                    <i class="fa fa-sliders push-5-r"></i> Configuration
                  </router-link>
                  </a>
                </li>

                <li class = "btnmenu" v-if="profileData.sharingInvitations.length>0">
                  <router-link class="text-white" :to="{name: 'sharing'}">
                    <i class="fa fa-share-alt push-5-r fa-1x"></i> {{labelSharingButton[actualLanguage]}} <i class="fa fa-exclamation-circle push-5-r fa-1x"></i>
                  </router-link>
                  </a>
                </li>


                <li class = "btnmenu">
                  <router-link class="text-white" :to="{name: 'help'}">
                      <i class="fa fa-question push-5-r"></i> {{labelHelpButton[actualLanguage]}}
                  </router-link>
                  </a>
                </li>


                <li class = "btnmenu" v-if="dashboardFlags.evsensMasterFlag">
                  <router-link class="text-white" :to="{name: 'evsensadmin'}">
                    <i class="fa fa-server push-5-r"></i> EV Sens Admin
                  </router-link>
                  </a>
                </li>

              </ul>

            </div>
          </div>
        </div>
      </div>
    </header>




    <div id="main-container">
      <div class="row">
        <div class="col-md-12">
          <hr></hr>
          <hr></hr>
        </div>
      </div>

      <div class="col-md-12 push 50"></div>
      <div class="col-md-12 push 50"></div>
      <div class="col-md-12 push 50"></div>
      <div class="col-md-12 push 50"></div>
      <div class="col-md-12 push 50"></div>
      

      <div v-if="profileData.profileInfo.policyAgreement.agreeFlag">

        <div v-if="profileDataReceivedFlag && flagBundleIsLoaded">
          <router-view></router-view>
        </div>
        <div v-else class="block-content">

          <div v-if="flagBundleIsLoading==false" class="col-sm-12">
            <h4 class="font-w200 text-center">{{ labelSession[actualLanguage] }}</h4>
            <div class="col-md-4"></div>
              <div class="col-md-4">
                <button v-on:click="refreshPage()" class="btn btn-block btn-success btn-lg push-10" type="button"><i
                  class="fa fa-repeat pull-left"></i>{{ labelSessionBtn[actualLanguage] }}
                </button>
              </div>
            <div class="col-md-4"></div>
          </div>
          <div v-else class="col-md-12 align-center push">
            <h3 class="font-w300 push-10">{{messageLoading[actualLanguage]}}</h3>
            <spinner></spinner>
          </div>

        </div>
      </div>
      <div v-else class="block-content">
        <policy-agreement></policy-agreement>
      </div>
    </div>

    <!-- Footer -->
    <footer id="page-footer" class="content-mini content-mini-full font-s12 bg-gray-lighter clearfix">
      <div class="pull-right">
        <a class="font-w600" href="https://evsens.ca" target="_blank">EV Sens </a> &copy; <span class="js-year-copy">2020</span>
      </div>
    </footer>
    <!-- END Footer -->


  </div>
  <!-- END Page Container -->

  </body>
</template>






<script>

  import Modal from '@/components/Modal'
  import LoadingBar from '@/components/LoadingBar'
  import ErrorView from '@/views/shared/ErrorView.vue'
  import PolicyAgreement from '@/components/PolicyAgreement'
  import FindElement from '@/components/FindElement'
  import Spinner from '@/components/Spinner.vue'
  import ProfileView from '@/views/profile/Index.vue'
  import SharingItem from '@/views/sharing/SharingItem.vue'
  import ConfigGroup from '@/views/configuration/ConfigGroup'
  import OrganizationDisplay from '@/views/profile/OrganizationDisplay'

  import HelpSection from '@/views/help/Index'
  

  import {mapState,mapActions} from 'vuex'

  export default {
    name: 'app',
    components: {
      Modal,
      ErrorView,
      LoadingBar,
      PolicyAgreement,
      FindElement,
      Spinner,
      ProfileView,
      ConfigGroup,
      SharingItem,
      OrganizationDisplay,
      HelpSection
    },
    data() {
      return {
        //---------------------------------------------
        //Variable pour handler l'affichage
        //Voir: https://forum.vuejs.org/t/opinions-how-do-you-handle-different-functionality-on-mobile-vs-desktop/19228/6
        mobile : window.innerWith <=700,
        navMenuFontSize : 3,

        displayHeadMenu : true,
        displayHeadMenuShowHideButton : true,
        displayElIot : window.innerWidth >=1000,
        displayHideHeadMenuOpen: {FR: 'Afficher Entête', EN: 'Display Head Menu'},
        displayHideHeadMenuClose: {FR: 'Cacher Entête', EN: 'Hide Head Menu'},
        //--------------------------------------------

        displayNavBar: false,
        actualLanguage: "FR",
        displayEvsensAdminFlag: false,
        actualGroupName: '',
        groupSelect1: -1,
        groupSelect2: -1,
        groupSelect3: -1,
        groupSelect4: -1,
        displayGroupSelector2to4: [false, false, false],
        actualBundleName: '',

        displayBundleSelector1to3: [false, false, false],

        navBarLink: [],
        navIndexGU: [],
        navIndexGS: [],
        navIndexGUTempo: [],
        navIndexGSTempo: [],
        flagDisplayHome: true,
        flagBundleIsLoading : false,
        flagBundleIsLoaded : false,
        flagBundleSelected: false,
        flagArborescenceIsLoading : true,
        displayListSharingFlag: true,
        groupIsDeleting:false,

        flagDisplayProfileView : false,
        flagDisplayCostSplittingMenu : false,

        groupInOrganizationIsCreating: false,
        groupInGroupIsCreating: false,

        //flagGroupSubGroupFlag:[],

        headerMenuSelectedTab : 3,

        actualOrganizationIndex: 0,

        //-------------------------------------------
        //Variables for finding tool
        //-------------------------------------------
        stringToFind : '',
        searchDoneFlag : false,
        researchInProgress : false,
        researchResults:[],

        //-------------------------------------------
        //Variables for homeTabMenu
        //-------------------------------------------
        displayHomeTab : false,
        test : 1,
        homeTabMenuSelector : [true, false, false, false],
        homeTabMenuProfile: {FR: 'Mon Profile', EN: 'My Profile'},
        homeTabMenuOrganizations: {FR: 'Mes Organisations', EN: 'My Organizations'},
        homeTabMenuFirstLevelGroup: {FR: 'Création de groupe', EN: 'Group creator'},
        homeTabMenuResearch: {FR: 'Recherche', EN: 'Research'},
        homeTabMenuHelp: {FR: 'Aide', EN: 'Help'},

        sectionLabelOrganization:{FR: "Mes Organisations", EN: 'My Organizations'},
        buttonLabelCreateOrganization:{FR: "Créer une organisation", EN: 'Create an organization'},
        buttonHelpManagerVersionDocumentation:{FR: "AIDE : Explication de la version gestionaire de la plateforme web", EN: 'HELP : Explanation documentation of the web platform manager version'},
        massageOrganizationRequired:{FR: "Une organisation est requise pour accéder à la plateforme gestionaire.", EN: 'An organization is required to access the manager platform version.'},


        //-------------------------------------------
        //New NAV MEnu
        //-------------------------------------------
        groupTempo: {},
        groupParentTempo: {},
        flagPersonalGroupSelected: false,
        flagFirstLevelGUSelector: true,
        flagGroupInParentSelect: [],
        flagGroupSelected: false,
        flagGroupSelectedByBundle: false,
        groupParentId: 'TBD',

        //Flag to display the section to support customer
        //to add the bundle of an existing customer
        //or create in advance a customer to preconfigure it's system
        flagShowCustomerSupportSection : false,

        bundleIsLoading : false,
        bundleTempo: {},
        subBundleTempo: [],
        bundleParentTempo: {'bundles': []},
        flagBundleInParentSelect: [],
        bundleParent: '',
        bundleParentId: 'TBD',
        tata: '',

        parentContainer : 'NA',

        messageAcceuil: {FR: 'Bonjour ', EN: 'Hi '},
        messageLoading: {FR: 'Chargement...', EN: 'Loading...'},
        labelProfileButton: {FR: 'Mon profile', EN: "My profile"},
        labelPortButton: {FR: 'Port de recharge', EN: "Charging port"},
        labelMesElcButton: {FR: 'Mesures', EN: "Measurements"},
        labelAlertsButton: {FR: 'Mes alertes', EN: "My alerts"},
        labelSplitCostButton: {FR: 'Répartiteur coûts', EN: "Cost splitting"},
        labelGrpButton: {FR: 'Groupe', EN: "Group"},
        labelHelpButton: {FR: 'Aide', EN: "Help"},
        labelSharingButton: {FR: 'Réception de partage', EN: "Sharing reception"},

        labelSession: {
          FR: 'Votre session est expirée, vous devez rafraichir votre session.',
          EN: "Your session is expired, you need to refresh your session"
        },
        labelSessionBtn: {FR: 'Rafraichir ma session', EN: "Refresn my session"},
        sharingInvitationsPopUp: {FR: "Vous avez reçu une invitation de partage, utilisez le menu ''Réception de partage'' pour traiter l'invitation", EN: "You receive a sharing invitation, you must go in the ''Sharing reception'' menu to manage this invitation."},
        sharingInvitationsPopUp2: {FR: "Vos partages sont disponibles en navigant dans vos groupes ou système et/ou en sélectionant le menu ''Réception de partage''", EN: "Your sharing are available by navigating in your Group or Systems or by accessing the ''Sharing reception'' menu to manage theses invitations."},

        buttonLabelRefresh: {FR: 'Actualiser', EN: 'Refresh'},
        menuLabelGroup: {FR: 'Groupes', EN: 'Groups'},
        menuLabelSystem: {FR: 'Systèmes', EN: 'Systems'},
        buttonLabelReadSystem: {FR: 'Lire le système', EN: 'Read System'},
        textMessageSelectAndPressReadSystem:{FR: 'Sélectionné le système et appuyer sur le bouton "Lire le système"', EN: 'Select your system and press "Read System" button'},
        buttonLabelReadRefreshSystem: {FR: 'Lire/Rafraichir les données du Système', EN: 'Read/Refresh System datas'},
        textLabelCreateFirstLevelGroup: {FR: 'Création de Groupe de premier niveau', EN: 'Create first level Group'},
        textIndicationCreateFirstLevelGroup: {FR: "Création de Groupe de premier niveau à l'organisation", EN: 'Create first level Group to the Organization'},
        buttonLabelSelectGroup: {FR: "Sélection de l'Organisation", EN: 'Organization selection'},
        buttonLabelCreateFirstLevelGroup: {FR: 'Créer un Groupe de premier niveau', EN: 'Create first level Group'},
        textYouReceiveGroupSharing: {FR: "Vous avez reçu un partage de Groupe", EN: 'You received Group sharing'},
        textYouReceiveSystemSharing: {FR: "Vous avez reçu un partage de Système", EN: 'You received System sharing'},
        blocLabelSelectAddGroupOrSystem: {FR: "Navigation et gestion de Groupe", EN: 'Navigation and Group management'},
        textIndicationSelectAddGroupOrSystem: {FR: "Sélectionnez un Groupe ou un System dans le menu de navigation (à gauche).", EN: 'Select Group or System in navigation menu (left).'},
        textIndicationAddOrModifyGroup: {FR: "Vous pouvez créer un sous groupe ou modifier les configurations du groupe sélectionné.", EN: 'You can create a subgroup or modify the configurations of the selected group.'},

        blocLabelAddComponentToGroupe: {FR: "Ajout de Sous-Groupe et Systèmes", EN: 'Create Sub-Group or System'},
        blocLabelConfigGroup: {FR: "Configuration du groupe", EN: 'Group configuration'},
        buttonLabelAddSubGroup: {FR: "Ajouter un Sous-Groupe", EN: 'Add Sub-Group'},
        buttonLabelAddSystemToGroup: {FR: "Ajouter un Système", EN: 'Add System'},
        buttonLabelShareThisGroup: {FR: "Partager ce Groupe", EN: 'Share this Group'},
        buttonLabelDeleteGroup: {FR: "Supprimer le Groupe sélectionné", EN: 'Delete selected Group'},
        textIndicationSelectGroupOrSystem: {FR: "Sélectionnez un Groupe ou un Système dans le menu de navigation (à gauche).", EN: 'Select Group or System in navigation menu (left).'},

        findElementSectionLabel:{ FR: "Recherche d'élément",EN: "Search element"},
        findElementSearchLabel: { FR: "Rechercher",EN: "Search"},
        findElementNoResults: { FR: "Aucun résultats",EN: "No results"},
        researchTableTitleType:{ FR: "Type",EN: "Type"},
        researchTableTitlePath:{ FR: "Chemin d'accèes",EN: "Access Path"},
        researchTableTitleName:{ FR: "Nom",EN: "Name"},
        researchTableTitleRefName:{ FR: "Nom de référence",EN: "Reference Name"},
        researchTableTitleAction:{ FR: "Ouvrir",EN: "Open"},


        userAcessLevel2Flag : false,

        groupConfigViewFlag : false,
        groupConfigEditFlag : false,
        groupConfigDeleteFlag : false,
        groupSharingEnableFlag : false,
        

        sidebarIsActive: false,

        groupConfigEditFlag : false,

      }
    },

    computed: {
      ...mapState('sessionStore', ['userEmail', 'profileData', 'dashboardFlags', 'groupArborescence', 'actualGroup', 'actualBundle', 'profileDataReceivedFlag', 'displayAdminFlag', 'navIndex']),
      ...mapState('groupStore', ['actualGroupLevel'])
    },


    watch: {
      profileData() {
        if(this.profileData.licences.length > 0)
        {
          this.groupConfigEditFlag = this.findPermissionItemValue(this.profileData.licences[0].permissions.group,'groupConfigEdit')
          this.userAcessLevel2Flag = this.findPermissionItemValue(this.profileData.licences[0].permissions.user,'userAdminAccessLevel02')
        }

        this.flagDisplayProfileView = false
        this.displayListSharingFlag = false
        this.$nextTick(() => {
          this.displayListSharingFlag = true
          this.flagDisplayProfileView = true
        });

        this.parentContainer = this.profileData.profileId

        //console.log('--!!--DASHBOARD:WATCHER:profileData')
        this.$store.dispatch('sessionStore/setParentContainer', this.parentContainer)
      },

      groupArborescence() {
        //console.log('---DASHBOARD:WATCHER:ARBORESCENCE----STEP 1----')
        //console.log(this.groupArborescence)

        if (this.navBarLink.length > 0) {
          this.navIndexGUTempo = this.navBarLink[this.navBarLink.length - 1].IndexGU
          this.navIndexGSTempo = this.navBarLink[this.navBarLink.length - 1].IndexGS
          this.navIndexGU = []
          this.navIndexGS = []
          this.groupParentId = this.profileData.profileId
        }

        this.navBarLink = []
        this.refreshNavMenu()

        //console.log('Watcher:Arborescence:groupParentTempo:')
        //console.log(this.groupParentTempo)

        //Cette condition de sharing invitation length =0 causait problème. Donc cette condition
        //est désactivée à la mettant à < 100 mais quand même gardé au cas ou on trouverait pourquoi
        //cela avait été implémenté.

        if(this.profileData.sharingInvitations.length<100){
            if (this.dashboardFlags['evsensAdminFlag'] == false && this.navBarLink.length == 0) {
              //console.log('--DASHBOARD:WATCHER:Arborescence:Load Base Group and bundle')
              this.navIndexGUTempo = []
              this.navIndexGSTempo = []
              this.selectFirstLevelGroup(0)

              //console.log('--Group Parent Tempo---')
              //console.log(this.groupParentTempo)
              //console.log('--Bundle Parent Tempo---')
              //console.log(this.bundleParentTempo)

              if (this.bundleParentTempo.bundles.length == 1 || this.profileData.licences.length==0) {
                this.selectFirstLevelBundle(0)
              }

              this.$store.dispatch('sessionStore/setParentContainer', this.computeParentContainerPrefix()+':'+this.actualGroup.group_id)
            }
        }



      }
    },


    methods: {
      ...mapActions('overlayStore', ['showModal']),

      displaySidebar() {
        this.sidebarIsActive = !this.sidebarIsActive;
      },

      logOut() {
        this.$store.dispatch('sessionStore/logOut').then(() => {
          this.$router.push({name: "login"})
        })
      },

      refreshPage() {
        console.log('Dashboard:RefreshPage called')
        document.location.reload()
      },

      toggleLanguage() {
        if (this.actualLanguage == 'FR') {
          this.actualLanguage = 'EN'
          localStorage.language = 'EN'
        } else {
          this.actualLanguage = 'FR'
          localStorage.language = 'FR'
        }
        this.$store.dispatch('sessionStore/updatelanguage', {language: this.actualLanguage}).then(() => {
          this.location.reload()
        })
      },





      checkDashboardNews(){
        //console.log(this.profileData)

        for (var m = 0; m < this.profileData.dashboard_news.length; m++) {
          if (this.profileData.dashboard_news[m].readFlag==false){
            var modalParameters = {'newsIndex':m}
            this.$store.dispatch('overlayStore/setParameters',modalParameters)
            this.showModal('dashboard-news')
          }
        }
      },







      actualiserArborescence() {
        this.flagBundleIsLoading = true
        this.flagArborescenceIsLoading = true
        this.$store.dispatch('sessionStore/refreshProfileData')
        .then((response) => {
            this.$store.dispatch('sessionStore/getGroupArborescence')
            .then((response) => {
              this.flagArborescenceIsLoading = false
              if(this.flagBundleSelected){
                this.loadSelectedBundle()
              }else{
                this.flagBundleIsLoading = false
              }
              
              //this.flagBundleIsLoading = false
            })
        })

      },

      toggleShowHideHead(){
        if(this.displayHeadMenu){this.displayHeadMenu = false}else{this.displayHeadMenu=true}
      },

      toggleHomeTabMenuSelector(index){
          this.displayHomeTab = false
          for(var n=0;n<this.homeTabMenuSelector.length;n++){this.homeTabMenuSelector[n]=false}
          this.homeTabMenuSelector[index]=true
          //Comprend pas mais besoin de cette ligne pour que ca fonctionne !!
          this.test = index
          this.displayHomeTab = true
      },

      openMultiGroupDocumentation() {
        var localUrl ='https://s3.amazonaws.com/evsenscloud.com/documents/Description_Portail_Multi_Groupe_V1P00.pdf';      
        window.open(localUrl, '_blank');  
      },

      goHomeGroup(index) {
        this.flagDisplayHome = true
        this.flagGroupSelectedByBundle = false
        this.flagBundleSelected = false
        this.flagBundleIsLoaded = false
        //this.flagSubBundleSelected = false
        this.groupParentId = this.profileData.profileId

        this.$store.dispatch('sessionStore/setActualBundle', {'bundle_id':'!!NONE!!','bundle_name': '!!None!!'})
        this.$store.dispatch('sessionStore/setActualGroup', {'group_id':'!!NONE!!','permissions': {'GrpLinkedProfileRead': [false]}})


        this.navBarLink = []
        this.navIndexGU = []
        this.navIndexGS = []
        this.flagGroupSelected = false
        this.flagGroupInParentSelect = []
        this.groupParentTempo = this.groupArborescence
        for (var m = 0; m < this.groupParentTempo.length; m++) {
          this.flagGroupInParentSelect.push(false)
        }
        this.selectGroupFromNav()
        this.parentContainer = this.profileData.profileId

        //console.log('--!!--DASHBOARD:GoHomeGroup')
        this.$store.dispatch('sessionStore/setParentContainer', this.computeParentContainerPrefix()+':'+this.parentContainer)

      },

      goBackNav(index) {
        this.navBarLink = this.navBarLink.splice(0, index + 1)
        this.navIndexGUTempo = this.navBarLink[index].IndexGU
        this.navIndexGSTempo = this.navBarLink[index].IndexGS
        this.navIndexGU = []
        this.navIndexGS = []

        var selectedItemIsBundle = (this.navBarLink[index].Type == 'GS')
        if (this.navBarLink[index].Type == 'GU') {
          this.flagBundleSelected = false
          this.flagBundleIsLoaded = false
        }
        if (this.actualBundle.bundle_name == 'None') {
          this.flagBundleSelected = false
        }
        this.navBarLink = []
        this.refreshNavMenu()

        //console.log('SELECTED ITEM TYPE')
        //console.log(selectedItemIsBundle)
        if(selectedItemIsBundle){this.loadSelectedBundle()}
      },

      refreshNavMenu() {
        this.groupParentTempo = this.groupArborescence
        this.bundleParentTempo = {'bundles': []}
        this.groupParentId = this.profileData.profileId


        if (this.navIndexGUTempo.length > 0) {
          this.selectFirstLevelGroup(this.navIndexGUTempo[0])
          for (var n = 1; n < this.navIndexGUTempo.length; n++) {
            this.selectSecondLevelGroup(this.navIndexGUTempo[n])
          }
          this.flagGroupInParentSelect = []

          for (var n = 0; n < this.groupParentTempo.length; n++) {
            this.flagGroupInParentSelect.push(false)
          }
          this.flagGroupInParentSelect[this.navIndexGU[this.navIndexGU.length - 1]] = true

          if (this.navIndexGSTempo.length > 0) {
            this.selectFirstLevelBundle(this.navIndexGSTempo[0])
            for (var n = 1; n < this.navIndexGSTempo.length; n++) {
              this.selectSecondLevelBundle(this.navIndexGSTempo[n])
            }
          }

          this.flagBundleInParentSelect = []
          for (var n = 0; n < this.bundleParentTempo.bundles.length; n++) {
            this.flagBundleInParentSelect.push(false)
          }
          this.flagBundleInParentSelect[this.navIndexGS[this.navIndexGS.length - 1]] = true
        }


        this.$store.dispatch('sessionStore/setActualNavIndex', {
          'GU': this.navIndexGU,
          'GS': this.navIndexGS,
          'groupParentId': this.groupParentId,
          'bundleParentId': this.bundleParentId
        })
      },


      //--------------------------------------------
      //Fonctions de navigation
      //--------------------------------------------
      selectFirstLevelGroup(index) {
        //console.log("selectFirstLevelGroup")

        this.flagBundleSelected = false
        this.flagBundleIsLoading = false

        for (var n = 0; n < this.groupParentTempo.length; n++) {
          this.flagGroupInParentSelect[n] = false
        }

        if (index == 0 && this.navIndexGU.length <= 1) {
          this.flagPersonalGroupSelected = true
        } else {
          this.flagPersonalGroupSelected = false
        }


        this.bundleParentTempo = this.groupParentTempo[index]
        //console.log(this.bundleParentTempo)
        this.flagBundleInParentSelect = []
        for (var n = 0; n < this.bundleParentTempo.bundles.length; n++) {
          this.flagBundleInParentSelect.push(false)
        }

        
        this.flagGroupInParentSelect[index] = true
        this.flagGroupSelected = true
        this.flagDisplayHome = false
        if (this.navIndexGU.length == 0) {
          this.navIndexGS = []
          this.navIndexGU.push(index)
          this.navBarLink = []
          this.selectGroupFromNav()
          var a = JSON.parse(JSON.stringify(this.navIndexGU))
          var b = JSON.parse(JSON.stringify(this.navIndexGS))
          this.navBarLink.push({'Name': this.actualGroup.group_name, 'Type': 'GU', 'IndexGU': a, 'IndexGS': b})
        } else {
          this.navIndexGU[this.navIndexGU.length - 1] = index
          this.navIndexGS = []
          this.selectGroupFromNav()
          var a = JSON.parse(JSON.stringify(this.navIndexGU))
          var b = JSON.parse(JSON.stringify(this.navIndexGS))
          this.navBarLink.splice(this.navBarLink.length - 1, 1, {
            'Name': this.actualGroup.group_name,
            'Type': 'GU',
            'IndexGU': a,
            'IndexGS': b
          })
        }
      },


      selectSecondLevelGroup(index) {
        //console.log("selectSecondLevelGroup")
        this.groupTempo = []
        this.flagBundleSelected = false
        this.flagBundleIsLoading = false

        //this.groupParentId = this.actualGroup.group_id
        //On construit un group Parent qui a une structure équivalent à l'arborescence.
        for (var n = 0; n < this.groupParentTempo[this.navIndexGU[this.navIndexGU.length - 1]].sub_group.length; n++) {
          this.groupTempo.push(this.groupParentTempo[this.navIndexGU[this.navIndexGU.length - 1]].sub_group[n])
        }

        this.groupParentTempo = this.groupTempo
        //Le bundle Parent doit avoir une structure équivalente au groupe usager
        this.bundleParentTempo = this.groupParentTempo[index]
        this.flagBundleInParentSelect = []
        for (var n = 0; n < this.bundleParentTempo.bundles.length; n++) {
          this.flagBundleInParentSelect.push(false)
        }

        for (var n = 0; n < this.groupParentTempo.length; n++) {
          this.flagGroupInParentSelect[n] = false
        }
        this.flagGroupInParentSelect[index] = true

        this.navIndexGS = []
        this.navIndexGU.push(index)
        this.selectGroupFromNav()

        var a = JSON.parse(JSON.stringify(this.navIndexGU))
        var b = JSON.parse(JSON.stringify(this.navIndexGS))
        this.navBarLink.push({'Name': this.actualGroup.group_name, 'Type': 'GU', 'IndexGU': a, 'IndexGS': b})
      },


      selectFirstLevelBundle(index) {
        //console.log("selectFirstLevelBundle")
        this.flagGroupSelectedByBundle = true
        this.flagBundleIsLoaded = false
        this.flagBundleInParentSelect = []
        this.flagBundleSelected = true
        for (var n = 0; n < this.bundleParentTempo.bundles.length; n++) {
          this.flagBundleInParentSelect.push(false)
        }

        this.flagBundleInParentSelect[index] = true
        if (this.navIndexGS.length == 0) {
          this.navIndexGS.push(index)
          this.selectGroupFromNav()
          var a = JSON.parse(JSON.stringify(this.navIndexGU))
          var b = JSON.parse(JSON.stringify(this.navIndexGS))
          this.navBarLink.push({'Name': this.actualBundle.bundle_name, 'Type': 'GS', 'IndexGU': a, 'IndexGS': b})
        } else {
          this.navIndexGS[this.navIndexGS.length - 1] = index
          this.selectGroupFromNav()
          var a = JSON.parse(JSON.stringify(this.navIndexGU))
          var b = JSON.parse(JSON.stringify(this.navIndexGS))
          this.navBarLink.splice(this.navBarLink.length - 1, 1, {
            'Name': this.actualBundle.bundle_name,
            'Type': 'GS',
            'IndexGU': a,
            'IndexGS': b
          })
        }
      },

      selectSecondLevelBundle(index) {
        //console.log("selectSecondLevelBundle")
        this.bundleTempo = {}
        this.subBundleTempo = []
        this.flagBundleIsLoaded = false

        for (var n = 0; n < this.bundleParentTempo.bundles[this.navIndexGS[this.navIndexGS.length - 1]].sub_bundle.length; n++) {
          this.subBundleTempo.push(this.bundleParentTempo.bundles[this.navIndexGS[this.navIndexGS.length - 1]].sub_bundle[n])
        }
        this.bundleTempo = {'bundles': this.subBundleTempo}
        this.bundleParentTempo = this.bundleTempo

        this.flagBundleInParentSelect = []
        for (var n = 0; n < this.bundleParentTempo.bundles.length; n++) {
          this.flagBundleInParentSelect.push(false)
        }
        this.flagBundleInParentSelect[index] = true

        this.navIndexGS.push(index)
        this.selectGroupFromNav()
        var a = JSON.parse(JSON.stringify(this.navIndexGU))
        var b = JSON.parse(JSON.stringify(this.navIndexGS))
        this.navBarLink.push({'Name': this.actualBundle.bundle_name, 'Type': 'GS', 'IndexGU': a, 'IndexGS': b})
      },


      selectGroupFromNav() {
        //console.log("selectGroupFromNav")
        if (this.navIndexGU.length > 0) {
          this.groupTempo = this.groupArborescence[this.navIndexGU[0]]
          this.groupParentId = this.profileData.profileId
          this.parentContainer = this.profileData.profileId

          for (var n = 1; n < this.navIndexGU.length; n++) {
            this.groupParentId = this.groupTempo['group_id']
            this.parentContainer = this.groupTempo['group_id']
            this.groupTempo = this.groupTempo.sub_group[this.navIndexGU[n]]
          }

          this.bundleTempo = {'bundle_id':'!!NONE!!','bundle_name': 'None'}
          this.bundleParentId = this.groupTempo['group_id']
          if (this.navIndexGS.length > 0) {
            this.flagDisplaySubGroupSelector = false
            this.parentContainer = this.groupTempo['group_id']

            this.bundleTempo = this.groupTempo.bundles[this.navIndexGS[0]]
            //this.bundleParentTempo=this.bundleTempo
            for (var n = 1; n < this.navIndexGS.length; n++) {
              //this.flagSubBundleSelected = true
              //this.bundleParentTempo = this.bundleTempo
              this.bundleParentId = this.bundleTempo['bundle_id']
              this.parentContainer = this.bundleTempo['bundle_id']
              this.bundleTempo = this.bundleTempo.sub_bundle[this.navIndexGS[n]]

            }
          }
        } else {
          this.groupTempo = {'group_id':'!!NONE!!','permissions': {'GrpLinkedProfileRead': [false]}}
          this.bundleTempo = {'bundle_id':'!!NONE!!','bundle_name': 'None'}
          this.groupParentId = this.profileData.profileId
        }


        this.$store.dispatch('sessionStore/setActualGroup', this.groupTempo)

        if('group' in this.actualGroup.permissions){
          this.groupConfigViewFlag = this.findPermissionItemValue(this.actualGroup.permissions.group,'groupConfigView')
          this.groupConfigEditFlag = this.findPermissionItemValue(this.actualGroup.permissions.group,'groupConfigEdit')
          this.groupConfigDeleteFlag = this.findPermissionItemValue(this.actualGroup.permissions.group,'groupConfigDelete')
          this.groupSharingEnableFlag = this.findPermissionItemValue(this.actualGroup.permissions.group,'groupSharingEnable')
        }


        this.$store.dispatch('sessionStore/setParentContainer', this.computeParentContainerPrefix()+':'+this.parentContainer)

        this.$store.dispatch('sessionStore/setActualBundle', this.bundleTempo)
        
        

         this.$store.dispatch('sessionStore/setActualNavIndex', {
        'GU': this.navIndexGU,
        'GS': this.navIndexGS,
        'groupParentId': this.groupParentId,
        'bundleParentId': this.bundleParentId
        })
        


        if (this.navIndexGS.length > 0 && this.bundleTempo.sub_bundle.length == 0) {
          if(this.bundleParentTempo.bundles.length == 1){
            this.loadSelectedBundle()
          }
          else{
            if (this.profileData.licences.length==0){
              this.loadSelectedBundle()
            }
          }
        }        

               
      },


      loadSelectedBundle(){
          //console.log('Load selected bundle called')
          this.flagBundleIsLoading = true
          this.flagBundleIsLoaded = false
          

          if('bundle_id' in this.bundleTempo){
            if(this.bundleTempo.bundle_id != '!!NONE!!'){

              this.flagBundleSelected = false
                var requestData = {'postAction':'ReadBundleData',
                                  'bundleId':this.bundleTempo.bundle_id}
                this.$store.dispatch('sessionStore/postBundle', requestData)
                    .then((response) => {
                    if(response.data.Code=='OK'){
                        //console.log('-Dashboard:loadSelectedBundle-')
                        //console.log(response.data.BundleData)
                        this.bundleTempo = response.data.BundleData

                        //console.log(this.bundleTempo)
                        if ('moduleCostSplit' in this.bundleTempo.bundleRights)
                        {
                          this.flagDisplayCostSplittingMenu = this.bundleTempo.bundleRights.moduleCostSplit.moduleEnable
                        }else{
                          this.flagDisplayCostSplittingMenu = false
                        }

                        this.$store.dispatch('sessionStore/setActualBundle', this.bundleTempo)
                        this.flagBundleSelected = true
                        this.flagBundleIsLoading = false
                        this.flagBundleIsLoaded = true

                        }
                        else{window.alert("La lecture a échouée. / Reading fail. (Dashboard:loadSelectedBundle)" )}
                    })
            }   
          }
      },


      computeParentContainerPrefix(){
        var returnString = ''
        for (var n = 0; n < this.navIndex.GU.length; n++) {
          returnString = returnString + this.navIndex.GU[n].toString()
        }
        for (var m = 0; m < this.navIndex.GS.length-1; m++) {
          returnString = returnString + this.navIndex.GS[m].toString()
        }
        return returnString
      },




      createNewGroupInOrganization() {
        if (this.actualLanguage == "FR") {
          var newGroupName = prompt("Nom du nouveau Groupe Usager", "Nom du groupe");
        } else {
          var newGroupName = prompt("New User Group name", "Group name");
        }

        if (newGroupName != null) {
          this.groupInOrganizationIsCreating = true
          var requestData = {
            'postAction': 'CreateNewGroupInOrganization',
            'groupName': newGroupName,
            'organizationId': this.profileData.managed_organizations[this.actualOrganizationIndex].organizationId
          }
          this.$store.dispatch('sessionStore/postGroup', requestData)
            .then((response) => {
              this.groupInOrganizationIsCreating = false
              if (response.data.Code == 'OK') {
                this.$store.dispatch('sessionStore/getGroupArborescence')
              }else{
                window.alert(response.data.PromptMessage[this.actualLanguage])
              }
            })
        }
      },


      createNewGroupInGroup() {
        if (this.actualLanguage == "FR") {
          var newGroupName = prompt("Nom de votre nouveau Groupe Usager à ajouter au Groupe : " + this.actualGroup.group_name, "Nom du groupe");
        } else {
          var newGroupName = prompt("New User Group name", "Group name");
        }
        //console.log(newGroupName)
        if (newGroupName != null) {
          this.groupInGroupIsCreating = true
          var requestData = {
            'postAction': 'CreateNewGroupInGroup',
            'groupName': newGroupName,
            'hostGroup': this.actualGroup.group_id
          }
          this.$store.dispatch('sessionStore/postGroup', requestData)
            .then((response) => {
              this.groupInGroupIsCreating = false
              if (response.data.Code == 'OK') {
                this.$store.dispatch('sessionStore/getGroupArborescence')
              }else{
                window.alert(response.data.PromptMessage[this.actualLanguage])
              }
            })
        }
      },

      createNewBundleInGroup() {
        if (this.actualLanguage == "FR") {
          var newBundleName = prompt("Nom de votre nouveau Groupe Système à ajouter au Groupe : " + this.actualGroup.group_name, "Nom du groupe système");
        } else {
          var newBundleName = prompt("New System name", "System Group name");
        }
        if (newBundleName != null) {
          var requestData = {
            'postAction': 'CreateNewBundleInGroup',
            'bundleName': newBundleName,
            'hostGroup': this.actualGroup.group_id
          }
          this.$store.dispatch('sessionStore/postGroup', requestData)
            .then((response) => {
              if (response.data.Code == 'OK') {
                //console.log(response)
                this.$store.dispatch('sessionStore/getGroupArborescence')
              }else{
                window.alert(response.data.PromptMessage[this.actualLanguage])
              }
            })
        }
      },


      deleteActualGroup(){
        //console.log(this.navIndex)
          if (this.actualLanguage == "FR"){
            var confirmation = prompt("Supprimer le Groupe: "+this.actualGroup.group_name, "Confirmer en écrivant DELETE");
          }else{
            var confirmation = prompt("Delete the Group: "+this.actualGroup.group_name, "Confirm by writing : DELETE");
          }
          if(confirmation == 'DELETE'){
              this.groupIsDeleting = true
              var hostId = this.navIndex.bundleParentId

              var requestData = {'postAction':'DeleteGroup',
                                  'groupId':this.actualGroup.group_id,
                                  'parentContainer':this.computeParentContainerPrefix()+':'+this.parentContainer,
                                  'hostId':hostId}
              this.$store.dispatch('sessionStore/postGroup', requestData)
                  .then((response) => {
                  if(response.data.Code=='OK'){

                      document.location.reload()

                      this.groupIsDeleting = false
                      }else{ window.alert("L'enregistrement a échoué. / Saving fail." )}
                  })
              }    
      },


      shareActualGroup(){
        var modalParameters = {'modalTitle':{FR: "Partage de Groupe Usager", EN: 'User Group sharing'},
                          'entityOwner':this.actualGroup.group_id,
                          'sharingType':'Group',
                          'entityId':this.actualGroup.group_id,
                          'entityReferenceName':this.actualGroup.group_name,
                          'displayAlertOptions':false,
                          'displayChannelOptions':true,
                          'displayDeviceOptions':true,
                          'displayBundleOptions':true,
                          'displayGroupOptions':true,
                          'displayUserOptions':false}

        this.$store.dispatch('overlayStore/setParameters',modalParameters)
        this.showModal('config-access-rules-form')
      },


      //-------------------------------------------------------------------
      //Fonctions for the section customer support
      //-------------------------------------------------------------------
      createNewUserProfile() {
        if (this.actualLanguage == "FR") {
          var newProfileEmail = prompt("Introduire le courriel du profile a créer:", "Courriel");
        } else {
          var newProfileEmail = prompt("Introduce the new profile email:", "Email");
        }

        if (this.actualLanguage == "FR") {
          var newUserFirstName = prompt("Introduire le prénom de l'usager:", "Prenom");
        } else {
          var newUserFirstName = prompt("Introduce the first name of the user:", "First name");
        }

        if (this.actualLanguage == "FR") {
          var newUserLastName = prompt("Introduire le nom de l'usager:", "Nom famille");
        } else {
          var newUserLastName = prompt("Introduce the last name of the user:", "Last name");
        }

        if (this.actualLanguage == "FR") {
          var newUserLanguage = prompt("Language (FR ou EN):", "FR / EN");
        } else {
          var newUserLanguage = prompt("Language (FR or EN):", "FR / EN");
        }

        if (newProfileEmail != null) {
          var requestData = {
            'postAction': 'CreateNewEVSensUser',
            'email': newProfileEmail,
            'firstName':newUserFirstName,
            'lastName':newUserLastName,
            'language':newUserLanguage,
            'frontEndVersion':process.env.FRONT_END_VERSION,
            'hostGroup': this.actualGroup.group_id
          }
          this.$store.dispatch('sessionStore/postGroup', requestData)
            .then((response) => {
              //console.log(response)
              if (response.data.Code == 'OK') {
                this.$store.dispatch('sessionStore/getGroupArborescence')
              }else{
                window.alert(response.data.PromptMessage[this.actualLanguage])
              }
            })
        }
      },


      addDefaultBundleOfExistingUser() {
        if (this.actualLanguage == "FR") {
          var profileEmail = prompt("Introduire le courriel du profile:", "Courriel");
        } else {
          var profileEmail = prompt("Introduce the profile email:", "Email");
        }

        if (profileEmail != null) {
          var requestData = {
            'postAction': 'AddDefaultBundleOfExistingUser',
            'email': profileEmail,
            'hostGroup': this.actualGroup.group_id
          }
          this.$store.dispatch('sessionStore/postGroup', requestData)
            .then((response) => {
              //console.log(response)
              if (response.data.Code == 'OK') {
                this.$store.dispatch('sessionStore/getGroupArborescence')
              }else{
                window.alert(response.data.PromptMessage[this.actualLanguage])
              }
            })
        }
      },


      removeSpecifiedSystem() {
        if (this.actualLanguage == "FR") {
          var bundleToRemove = prompt("Introduire le nom du système a retirer:", "Nom du système");
        } else {
          var bundleToRemove = prompt("Introduce the system to remove:", "System name");
        }

        if (bundleToRemove != null) {
          var requestData = {
            'postAction': 'RemoveSpecificBundle',
            'bundleToRemove': bundleToRemove,
            'hostGroup': this.actualGroup.group_id
          }
          this.$store.dispatch('sessionStore/postGroup', requestData)
            .then((response) => {
              //console.log(response)
              if (response.data.Code == 'OK') {
                this.$store.dispatch('sessionStore/getGroupArborescence')
              }else{
                window.alert(response.data.PromptMessage[this.actualLanguage])
              }
            })
        }
      },

      //-------------------------------------------------------------------
      //Fonctions for research in profile
      //-------------------------------------------------------------------

      researchInProfile(){
          var requestData = {
            'postAction': 'FindInProfile',
            'stringToFind': this.stringToFind,
          }
          this.researchInProgress=true
          this.searchDoneFlag=false
          this.$store.dispatch('sessionStore/postProfile', requestData)
            .then((response) => {
              this.researchInProgress=false
              
              if (response.data.Code == 'OK') {
                //console.log(response)
                this.searchDoneFlag=true
                this.researchResults=response.data.Results
              }else{
                window.alert(response.data.PromptMessage[this.actualLanguage])
              }
            })       
      },



      researchResultGoToPath(index){
        //this.navIndexGU = this.researchResults[index].NavGroup
        //this.navIndexGS = this.researchResults[index].NavBundle

        if(this.researchResults[index].NavGroup.length>0){
          this.selectFirstLevelGroup(this.researchResults[index].NavGroup[0])
          for (var n = 1; n < this.researchResults[index].NavGroup.length; n++){
            
            this.selectSecondLevelGroup(this.researchResults[index].NavGroup[n])
          }
        }

        if(this.researchResults[index].NavBundle.length>0){
          this.selectFirstLevelBundle(this.researchResults[index].NavBundle[0])
          for (var n = 1; n < this.researchResults[index].NavBundle.length; n++){
            this.selectSecondLevelBundle(this.researchResults[index].NavBundle[n])
          }
          this.loadSelectedBundle()
        }

      },



      findPermissionItemValue(permissionList,idToFind){
          var value = false
          for (var n = 0; n < permissionList.length; n++){
            if(permissionList[n].id == idToFind)
            {value = permissionList[n].value
            //console.log('Value found')
             //console.log(value)
            }
          }
          return value
      },



    },

    beforeCreate(){
         
        addEventListener('resize', () => {
          //console.log('------------------')
          //console.log(window.innerWidth)
          //console.log(window.innerHeight)
          this.mobile = window.innerWidth <= 700
          this.displayElIot = window.innerWidth >= 1100
          if(this.mobile == true){this.navMenuFontSize=2}else{this.navMenuFontSize=3}
        })

        if(this.mobile == true){this.navMenuFontSize=2}else{this.navMenuFontSize=3}
        
    },

    mounted() {
      //do something after mounting vue instance
      //this.$store.dispatch('sessionStore/refreshProfileData')
      //console.log('------DASHBOARD MOUNT-------')
      //console.log('ProfileDataReceive:')
      //console.log(this.profileDataReceivedFlag)
      //console.log('FlagBundleIsLoaded:' )
      //console.log(this.flagBundleIsLoaded)

      //console.log(this.actualBundle.bundle_id)
      //console.log(this.profileData.profileInfo)
      //console.log(this.profileData.profileInfo.profile_type)

      //--------------------------------------------------------
      //Check for Dashboard news
      //--------------------------------------------------------
      //process.env.BUILD_VERSION
      console.log(process.env.BUILD_VERSION)
      var thisDayUnix = (Math.floor(moment().unix()/(24*3600)))*(24*3600)+0



      this.toggleHomeTabMenuSelector(0)

      this.mobile = window.innerWidth <= 925
      this.$store.dispatch('sessionStore/refreshProfileData')
      .then((response) => {
        //console.log('-----PROFILE DATA READ-----')
        this.$store.dispatch('appliancesStore/get')
        this.$store.dispatch('appliancesStore/getSystems')

        //console.log('------DASHBOARD GET ARBORESCENCE-------')
        //console.log(response.data)


        if (localStorage.lastOpenUnixDay) {
          if(localStorage.lastOpenUnixDay != thisDayUnix){
            localStorage.lastOpenUnixDay = thisDayUnix
            this.checkDashboardNews()
          }
        } else {
          localStorage.lastOpenUnixDay = thisDayUnix
          this.checkDashboardNews()
        }

        
        //--ATTENTION- 
        //Le watcher de groupArborescence vérifie appel la fonction refreshNavMennu
        //De plus ils effectue une sélection automatique du groupe et bundle
        //en fonction de l'arborescence
        this.$store.dispatch('sessionStore/getGroupArborescence')
        .then((response) => {
            //console.log('-----ARBORESCENCE READ------')
            this.flagDisplayProfileView = true
            this.flagArborescenceIsLoading = false

            
            if(this.profileData.sharingInvitations.length>0){
              window.alert(this.sharingInvitationsPopUp[this.actualLanguage])
                if(this.dashboardFlags['evsensAdminFlag']){
                  window.alert(this.sharingInvitationsPopUp2[this.actualLanguage])
                }
              }


            //Tools to make customer Pre-Configuration
            //This flag allows to display a special button to creater new customer profile
            //and add the system of the customer to the actual displayed group
            if(this.profileData.profileInfo.profile_type['masterUserCode']){
              if(this.profileData.profileInfo.profile_type['masterUserCode'].includes("-EVSensAdmin")){
                  this.flagShowCustomerSupportSection = true                
              }
            }
            

            this.$router.push({name: 'measurements'})
        })

      })



      //this.displayEvsensAdminFlag=this.profileData.profileInfo.profile_type.masterUserCode.includes('EVSensAdmin')
      //https://stripe.com/docs/stripe-js/react
      //https://docs.stripe.com/js

      /*
      //RETRAIT STRIPE
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://js.stripe.com/v3/')
      document.head.appendChild(recaptchaScript)
      */

      if (localStorage.language) {
        this.actualLanguage = localStorage.language
      } else {
        this.actualLanguage = 'FR'
      }



    

      clearInterval()
      //setInterval(function(){ alert("---Allo je recalll---"); }, 30000);

    }
  }
</script>

<style>
  .bg-nav {
    background-color: #222;
    color: white;
  }

  .h1 {
    font-size: 32px; /* Taille de police par défaut */
  }
  .h2 {
    font-size: 20px; /* Taille de police par défaut */
  }
  .h3 {
    font-size: 16px; /* Taille de police par défaut */
  }
  .h4 {
    font-size: 16px; /* Taille de police par défaut */
  }
  .btnmenu {
    font-size: 14px; /* Taille de police par défaut */
  }
  /* Media Query pour les écrans de moins de 600px de large */
  @media (max-width: 950px) {

      .h1 {
          font-size: 26px; /* Taille de police réduite pour les petits écrans */
      }
      .h2 {
          font-size: 24px; /* Taille de police réduite pour les petits écrans */
      }
      .h3 {
          font-size: 16px; /* Taille de police réduite pour les petits écrans */
      }
      .h4 {
          font-size: 16px; /* Taille de police réduite pour les petits écrans */
      }
      .btnmenu {
        font-size: 10px; /* Taille de police par défaut */
      }      
  }


  @media (max-width: 600px) {

      .h1 {
          font-size: 20px; /* Taille de police réduite pour les petits écrans */
      }
      .h2 {
          font-size: 18px; /* Taille de police réduite pour les petits écrans */
      }
      .h3 {
          font-size: 12px; /* Taille de police réduite pour les petits écrans */
      }
      .h4 {
          font-size: 12px; /* Taille de police réduite pour les petits écrans */
      }
      .btnmenu {
        font-size: 10px; /* Taille de police par défaut */
      }        
  }

</style>



// WEBPACK FOOTER //
// Dashboard.vue?304c83c0